export const environment = {
    version: '2.4.4.5',
};
